const DRUMKIT_API_URL = process.env.DRUMKIT_API_URL;

export default DRUMKIT_API_URL;
